import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next"
import { clx } from "../../../../helpers/components"
import { SectionHeader } from "../../../shared/TitleHeader"
import { Button } from "../../../ui/Button"
import style from "./style.module.scss"

export const ModernTestimonialSection = () => {
    const { t } = useTranslation("translations")
    const submitReviewLabel = t("home-page.modern-testimonial-section.submitReview").replace(/\s*[→➜➝]\s*$/, "")
    const [currentIndex, setCurrentIndex] = useState(0)
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768)
        }
        
        checkMobile()
        window.addEventListener('resize', checkMobile)
        
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    const testimonials = [
        {
            id: 1,
            imgSrc: "/images/testimonial_Namegoli-Camba.png",
            clientName: "Namegoli Camba",
            clientCountryName: "Togo",
            message: t("home-page.testimonial-section.testimonial-1"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://www.trustpilot.com/users/69777a6a6709075d5e3be4e0"
        },
          {
            id: 2,
            imgSrc: null,
            clientName: "Manzamasso Jacques AKETI",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-8"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        },
         
        {
            id: 3,
            imgSrc: null,
            clientName: "Varline Fotsap",
            clientCountryName: "Cameroun",
            message: t("home-page.testimonial-section.testimonial-7"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/694ebd9a761722dc70c8f86f"
        },
        {
            id: 4,
            imgSrc: "/images/testimonial-Sebastien-Donan.png",
            clientName: "Sébastien Donan KOUGBLENOU",
            clientCountryName: "Bénin",
            message: t("home-page.testimonial-section.testimonial-6"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/69738c28c0a17e10459b4f25"
        },
       
       
        {
            id: 5,
            imgSrc: null,
            clientName: "Rachel Congo",
            clientCountryName: "Niger",
            message: t("home-page.testimonial-section.testimonial-5"),
            platform: "trustpilot",
            platformLabel: "Trustpilot",
            reviewUrl: "https://trustpilot.com/reviews/69cdeaf1227a9219e85a0c0"
        },
        
      
        {
            id: 6,
            imgSrc: null,
            clientName: "Aristide Kodzo Dzifa LOUMON",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-9"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        },
        {
            id: 7,
            imgSrc: null,
            clientName: "Abdoulaye Traoré",
            clientCountryName: "",
            message: t("home-page.testimonial-section.testimonial-10"),
            platform: "google",
            platformLabel: "Google Play",
            reviewUrl: "https://play.google.com/store/apps/details?id=com.izichange&pcampaignid=web_share"
        }
    ]

    const visibleTestimonials = isMobile 
        ? [testimonials[currentIndex]]
        : [
            testimonials[currentIndex],
            testimonials[(currentIndex + 1) % testimonials.length],
            testimonials[(currentIndex + 2) % testimonials.length]
        ]

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length)
    }

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)
    }

    return (
        <div className="container">
            <div className={style.testimonialContainer}>
                <SectionHeader
                    title={t("home-page.modern-testimonial-section.title")}
                    position="center"
                />
                
                <div className={style.carouselWrapper}>
                    <button 
                        className={`${style.navButton} ${style.prevBtn}`}
                        onClick={handlePrev}
                        aria-label="Previous testimonials"
                    >
                        ←
                    </button>

                    <div className={style.testimonialsWrapper}>
                        {visibleTestimonials.map((testimonial) => (
                            <ModernTestimonialCard
                                key={testimonial.id}
                                testimonial={testimonial}
                            />
                        ))}
                    </div>

                    <button 
                        className={`${style.navButton} ${style.nextBtn}`}
                        onClick={handleNext}
                        aria-label="Next testimonials"
                    >
                        →
                    </button>
                </div>

                <div className={style.ctaSection}>
                    <a href="https://www.trustpilot.com/evaluate/izichange.com " target="_blank" rel="noopener noreferrer">

                    <Button className={clx(style.ctaButton)} ariaLabel={submitReviewLabel} bgColor="izi-primary-gradient-color" color="#fff">
                        {submitReviewLabel}
                        <span
                            className={style.ctaArrow}
                            dangerouslySetInnerHTML={{
                                __html: `
                                    <svg width="27" height="12" viewBox="0 0 27 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 4.79283C1.30964 4.79283 0.75 5.35247 0.75 6.04283C0.75 6.73318 1.30964 7.29283 2 7.29283V4.79283ZM18.6087 7.29283C19.2991 7.29283 19.8587 6.73318 19.8587 6.04283C19.8587 5.35247 19.2991 4.79283 18.6087 4.79283V7.29283ZM18.6087 3.66393H17.3587H18.6087ZM21.2827 2.34785L20.5202 3.33835V3.33835L21.2827 2.34785ZM21.2827 9.73781L20.5202 8.7473L21.2827 9.73781ZM18.6087 8.42173H19.8587H18.6087ZM24.373 7.35891L25.1355 8.34942L24.373 7.35891ZM24.373 4.72675L25.1355 3.73624V3.73624L24.373 4.72675ZM2 7.29283H18.6087V4.79283H2V7.29283ZM23.6105 6.3684L20.5202 8.7473L22.0452 10.7283L25.1355 8.34942L23.6105 6.3684ZM19.8587 8.42173V3.66393H17.3587V8.42173H19.8587ZM20.5202 3.33835L23.6105 5.71725L25.1355 3.73624L22.0452 1.35734L20.5202 3.33835ZM19.8587 3.66393C19.8587 3.32297 20.25 3.13037 20.5202 3.33835L22.0452 1.35734C20.1311 -0.116135 17.3587 1.24837 17.3587 3.66393L19.8587 3.66393ZM20.5202 8.7473C20.25 8.95528 19.8587 8.76269 19.8587 8.42173L17.3587 8.42173C17.3587 10.8373 20.1311 12.2018 22.0452 10.7283L20.5202 8.7473ZM25.1355 8.34942C26.6491 7.18419 26.6491 4.90147 25.1355 3.73624L23.6105 5.71725C23.8241 5.88173 23.8241 6.20393 23.6105 6.3684L25.1355 8.34942Z" fill="white"/>
                                    </svg>
                                `
                            }}
                        />
                    </Button>
                    </a>
                </div>
            </div>
        </div>
    )
}

const ModernTestimonialCard = ({ testimonial }) => {
    const { t } = useTranslation("translations")

    const getPlatformUrl = (platform) => {
        switch(platform) {
            case 'google':
                return 'https://play.google.com/store/apps/details?id=com.izichange&hl=fr'
            case 'trustpilot':
                return 'https://www.trustpilot.com/review/izichange.com'
            case 'facebook':
                return '#facebook-reviews'
            default:
                return '#'
        }
    }

    const getInitials = (name) => {
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)
    }

    const reviewUrl = testimonial.reviewUrl || getPlatformUrl(testimonial.platform)

    return (
        <div className={style.modernCard}>
            <div className={style.cardContent}>
                {/* Profile + Name */}
                <div className={style.clientHeader}>
                    {testimonial.imgSrc ? (
                        <img 
                            src={testimonial.imgSrc} 
                            alt={testimonial.clientName}
                            className={style.avatar}
                        />
                    ) : (
                        <div className={style.avatarInitials}>
                            {getInitials(testimonial.clientName)}
                        </div>
                    )}
                    <div className={style.nameCountry}>
                        <p className={style.clientName}>{testimonial.clientName}</p>
                        <p className={style.clientCountry}>{testimonial.clientCountryName}</p>
                    </div>
                </div>

                {/* Stars */}
                <div className={style.starsContainer}>
                    {[...Array(5)].map((_, i) => (
                        <span key={i} className={style.star}>★</span>
                    ))}
                </div>

                {/* Message */}
                <p className={style.testimonialText}>
                    "{testimonial.message}"
                </p>

                {/* Platform Link */}
                <div className={style.platformLink}>
                    <a href={getPlatformUrl(testimonial.platform)} className={style.platformName}>
                        {testimonial.platformLabel}
                    </a>
                </div>

                {/* View Review Button */}
                <a href={reviewUrl} target="_blank" rel="noopener noreferrer" className={style.viewReviewBtn}>
                    {t("home-page.modern-testimonial-section.viewReview")}
                </a>
            </div>
        </div>
    )
}
